import { Stack } from "@mui/material";
import { get } from "aws-amplify/api";
import React, { useEffect, useRef, useState } from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./section3/Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";

const Podcast = ({ data: { body }, signUpFormData }) => {
  const [loader, setLoader] = useState(true);
  const [podcasts, setPodcasts] = useState([]);
  const [activePodcast, setActivePodcast] = useState(null);
  const [latestPodcast, setLatestPodcast] = useState(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    (async () => {
      const podcasts = await (
        await get({
          apiName: "community",
          path: "/spotify/episodes?limit=5&offset=0",
        }).response
      ).body.json();

      setPodcasts(podcasts);
      setActivePodcast(podcasts.items[0]);
      setLatestPodcast(podcasts.items[0]);
      setLoader(false);
    })();
  }, []);

  return (
    <Stack>
      <Section1
        {...body[0]}
        links={body[0].items}
        activePodcast={activePodcast}
        latestPodcast={latestPodcast}
        iframeRef={iframeRef}
      />

      <Section2 {...body[1]} />

      <Section3
        podcasts={podcasts}
        loader={loader}
        setActivePodcast={setActivePodcast}
        iframeRef={iframeRef}
        setPodcasts={setPodcasts}
      />

      <Section4 {...body[2]} />

      <Section5 signUpFormData={signUpFormData} />
    </Stack>
  );
};

export default Podcast;
